import TablePage from '@/found/components/table_page';

export default {
  extends: TablePage,
  props: {
    propsObj: Object,
  },
  data() {
    return {
      requestType: 'POST',
      params: { ruleBalanceId: this.propsObj.id },
    };
  },
  mounted() {
    this.getConfigList('detail_list');
  },
  methods: {},
};
